declare global {
    interface Window {
        iconsLibrary?: Record<string, string>;
    }
}

const getPathFromStorage = (pathKey: string): string | undefined => {
    return window?.iconsLibrary?.[pathKey];
};

export default getPathFromStorage;
